import React, { useEffect, useState } from "react";
import "./MaturityReport.scss";
import { useSelector, useDispatch } from "react-redux";
import LoanTable from "../../../components/LoanTable/LoanTable";
import { Box } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import LoanReportsTable from "../../../components/LoanReportsTable/LoanReportsTable";

const MaturityReport = ({startDate, endDate, duration, isCustomFilter}) => {
  const [reportData, setReportData] = useState([]);
  let user = useSelector((state) => state.login);

  useEffect(()=> {
    getReportData();
  },[duration, isCustomFilter]);

  const getReportData = async() => {
    try {
      const response = await commonRunQuery(255, `${startDate}/${endDate}`);
      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
        const reportsArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
        setReportData(reportsArray);
        console.log("MaturityReport_getReportData==========",reportsArray);
      } else {
        setReportData([]);
      }
      console.log("getReportData---------------",response);
    } catch (error) {
      console.log("getReportData_error==========",error);
    }
  }

  const columns = [
    {
      label: 'Loan ID',
      getValue: (row) => row.li?.LoanID ?? ''
    },
    {
      label: 'Borrower Name',
      getValue: (row) => row.record?.BorrowerName?.toString().trim() ? row.record?.BorrowerName : "-"
    },
    {
      label: 'Loan Amount',
      getValue: (row) => row.li?.LoanAmount ?? '',
      align: 'right',
      amount: true
    },
    {
      label: 'Start Date',
      getValue: (row) => row.li?.StartDate ?? ''
    },
    {
      label: 'Maturity Date',
      getValue: (row) => row.li?.MaturityDate?.toString().trim() ? row.li?.MaturityDate : "-"
    },
  ];

  return (
    <Box>
      {/* <LoanTable fakeData={filteredData} /> */}
      <LoanReportsTable 
        data={reportData} 
        columns={columns} 
        title="Maturity Report" 
        formatRow={(row) => [
          row.li?.LoanID,
          row.record?.BorrowerName,
          row.li?.LoanAmount,
          row.li?.StartDate,
          row.li?.MaturityDate
        ]} 
        author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
        />
    </Box>
  )
}

export default MaturityReport;
